<template>
  <div class="com-title f-ptb14">
    <div class="com-title-title">{{ title }}</div>
  </div>
</template>

<script lang="ts" setup>
/**
 * @author lifei
 * @description 标题
 */
import { ref, computed, reactive, onBeforeMount } from 'vue'

defineOptions({
  name: 'XHBaseTitle',
})

type TProps = {
  classname?: string
  title: string
}

type TState = {}

const props = withDefaults(defineProps<TProps>(), {
  classname: '',
})

const emit = defineEmits<{}>()
const state = reactive<TState>({})
</script>

<style lang="scss" scoped>
.com-title {
  display: flex;
  font-size: 18px;
  .com-title-title {
    &::before {
      display: inline-block;
      content: '';
      width: 3px;
    }
  }
}
</style>
